export enum PartDetailsDrawerTab {
  COSTS = 'costs',
  HISTORY = 'history',
  INVENTORY = 'inventory',
  SET_UP = 'setUp',
  UOM = 'uom',
}
